module.exports = __webpack_public_path__ + "img/patate-al-forno.f0d6741a.png";